import { createStyles, makeStyles, styled, Typography } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
const {
  DARK_BUTTON_BACKGROUND,
  DARK_BUTTON_HOVER,
  DARK_CONTAINER_BORDER,
  DARK_CONTAINER_FIELDS_ON_CARD,
  DARK_FIELDS_ON_CARD_HEADER_LINE,
  DARK_TEXT,
  LIGHT_CONTAINER_FIELDS_ON_CARD,
  LIGHT_HEADER_LINE,
  OFFWHITE_BUTTON_BACKGROUND,
  PLAIN_TEXT,
  PRIMARY_HEADER_LINE,
} = COLORS;

export const useStyles = makeStyles((theme) =>
  createStyles({
    heading: {
      position: 'relative',
      color: theme.palette.type === 'dark' ? PLAIN_TEXT : DARK_TEXT,
      borderBottom: '1px solid',
      borderBottomColor: theme.palette.type === 'dark' ? DARK_FIELDS_ON_CARD_HEADER_LINE : LIGHT_HEADER_LINE,
      alignItems: 'center',
      paddingBottom: 20,
      marginBottom: 20,

      '&::before': {
        content: '""',
        background: PRIMARY_HEADER_LINE,
        height: '1px',
        position: 'absolute',
        width: 42,
        bottom: '-1px',
      },
    },

    buttonCls: {
      marginTop: 10,
      height: '50px !important',
      borderRadius: 8,
      textTransform: 'unset',
      maxWidth: '100%',
      fontSize: 15,
    },
    termsContainer: {
      maxHeight: 390,
      background: theme.palette.type === 'dark' ? DARK_CONTAINER_FIELDS_ON_CARD : LIGHT_CONTAINER_FIELDS_ON_CARD,
      padding: '20px 25px',
      borderRadius: 8,
      marginBottom: 15,
      [theme.breakpoints.down('xs')]: {
        maxHeight: 'unset',
      },
    },
    termsWrap: {
      overflow: 'auto',
      maxHeight: 350,
      [theme.breakpoints.down('xs')]: {
        maxHeight: 'unset',
      },
    },

    sigCanvas: {
      backgroundColor: LIGHT_CONTAINER_FIELDS_ON_CARD,
      marginTop: 12,
      border: `1px solid ${DARK_CONTAINER_BORDER}`,
      cursor: 'crosshair',
      borderRadius: 8,
      marginRight: 100,
      width: 320,
      maxHeight: 150,
      minHeight: 120,
    },
    backBtn: {
      background: theme.palette.type === 'dark' ? DARK_BUTTON_BACKGROUND : OFFWHITE_BUTTON_BACKGROUND,
      color: theme.palette.type === 'dark' ? 'white' : DARK_TEXT,
      '&:hover': {
        background: theme.palette.type === 'dark' ? DARK_BUTTON_HOVER : '',
      },
    },
    buttonsContainer: {
      display: 'flex',
      gap: 10,

      [theme.breakpoints.down('xs')]: {
        marginTop: 10,
        flexDirection: 'column',
      },
    },
  }),
);

// New Styled
export const TextSwitchColor = styled(Typography)(({ theme, size, weight }: any) => ({
  color: theme.palette.type === 'dark' ? PLAIN_TEXT : DARK_TEXT,
  fontSize: size || 16,
  fontWeight: weight || undefined,
}));
